// questionPaperGeneratorSvc.js
import axios from 'axios';
import lstModules from 'common/json/lstModules.json';

// Java backend (existing) - patterns/sections/question-types, prod pe hi rahega
const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;

// AI Question Paper Generator — prod (lstModules.json ka aiQpGenerator ab 'main' jaisa hi prod URL hai)
const aiQpURL = lstModules['aiQpGenerator'].url + ':' + lstModules['aiQpGenerator'].port;

// DEMO: hardcoded prod tokenid (login bypass). Expire hone par naya daalna padega.
const DEMO_TOKEN = 'em8w04f5d3o196n4slngsl21wvi6b8';
export function getTokenId() { return localStorage.getItem('tokenid') || DEMO_TOKEN; }

/* ----------------------- AI QP GENERATOR (kmsg.sms.smsQpGenerator) ----------------------- */

// Class list — sirf woh classes jinke liye QP generation allowed hai (qp_generation_allowed=1)
export const getClassListSvc = (cb) => {
    axios({
        url: aiQpURL + '/sms/qp_mst/list_class',
        method: 'POST',
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    })
        .then((r) => cb({ status: r.data.SvcStatus, lstClass: r.data.lstClass, message: r.data.SvcMsg }))
        .catch((e) => cb({ status: 'Exception', message: e.message }));
};

// Subject list — class ke hisaab se
export const getSubjectListSvc = (clsId, cb) => {
    axios({
        url: aiQpURL + '/sms/qp_mst/list_subject',
        method: 'POST',
        params: { clsId },
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    })
        .then((r) => cb({ status: r.data.SvcStatus, lstSubject: r.data.lstSubject, message: r.data.SvcMsg }))
        .catch((e) => cb({ status: 'Exception', message: e.message }));
};

// Exam list — NAYA (Harry Sir ke restructure mein add hua)
export const getExamListSvc = (cb) => {
    axios({
        url: aiQpURL + '/sms/qp_mst/list_exam',
        method: 'POST',
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    })
        .then((r) => cb({ status: r.data.SvcStatus, lstExam: r.data.lstExam, message: r.data.SvcMsg }))
        .catch((e) => cb({ status: 'Exception', message: e.message }));
};

// Question types — REAL prod API (jo examPatternCreatorSvc.js bhi use karta hai, same source of truth)
export const getQuestionTypeListSvc = (cb) => {
    axios({
        url: httpURL + '/sms/qp_pattern/list_qus_type',
        method: 'POST',
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    })
        .then((r) => cb({ status: r.data.SvcStatus, lstQusType: r.data.lstQusType, message: r.data.SvcMsg }))
        .catch((e) => cb({ status: 'Exception', message: e.message }));
};

// Generate — ab sirf 4 IDs bhejte hain (patternId, clsId, subjectId, examId), backend khud
// class/subject naam, pattern sections, aur chapters (exam+syllabus se) resolve karta hai.
export const generatePaperSvc = (patternId, clsId, subjectId, examId, cb) => {
    // Dropdown values (e.target.value) hamesha string hoti hain HTML mein — backend (RQQPGenerator)
    // int fields expect karta hai, isliye explicitly Number() se convert karke bhej rahe hain.
    const objData = JSON.stringify({
        patternId: Number(patternId),
        clsId: Number(clsId),
        subjectId: Number(subjectId),
        examId: Number(examId),
    });
    axios({
        url: aiQpURL + '/sms/qp_api/generate_qp',
        method: 'POST',
        params: { objData },
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    })
        .then((r) => cb(r.data))
        .catch((e) => cb({ status: 'Exception', message: (e.response && e.response.data && e.response.data.SvcMsg) || e.message }));
};

/* ----------------------- JAVA BACKEND (reuse) ----------------------- */

// Pattern list — REAL prod (DEMO_TOKEN se auth)
export const getQpPatternListSvc = (clsId, cb) => {
    axios({
        url: httpURL + '/sms/qp_pattern/list',
        method: 'POST',
        params: { clsId },
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    })
        .then((r) => cb({ status: r.data.SvcStatus, lstPattern: r.data.lstQpPattern, message: r.data.SvcMsg }))
        .catch((e) => cb({ status: 'Exception', message: e.message }));
};

// Pattern sections — REAL prod (DEMO_TOKEN se auth)
export const getPatternSectionListSvc = (patternId, cb) => {
    axios({
        url: httpURL + '/sms/qp_pattern/list_pattern_section',
        method: 'POST',
        params: { patternId },
        headers: { tokenid: getTokenId() },
        withCredentials: true,
    })
        .then((r) => cb({ status: r.data.SvcStatus, lstPatternSection: r.data.lstQpPatternSection, message: r.data.SvcMsg }))
        .catch((e) => cb({ status: 'Exception', message: e.message }));
};
